import { FC, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { CHART_INK } from './agencyChartTheme';

const useStyles = createUseStyles({
    banner: {
        display: 'flex',
        gap: 10,
        alignItems: 'flex-start',
        padding: '11px 14px',
        borderRadius: 10,
        border: '1px solid var(--ion-color-warning-shade)',
        background: 'rgba(242, 195, 26, 0.12)',
        fontSize: 13,
        lineHeight: 1.5,
        color: CHART_INK.strongLabel
    },

    dismiss: {
        flexShrink: 0,
        alignSelf: 'flex-start',
        marginTop: -2,
        padding: '2px 8px',
        border: 'none',
        borderRadius: 6,
        background: 'none',
        font: 'inherit',
        fontSize: 16,
        lineHeight: 1.2,
        color: CHART_INK.strongLabel,
        cursor: 'pointer',

        '&:hover': {
            background: 'rgba(0, 0, 0, 0.06)'
        }
    },

    tag: {
        flexShrink: 0,
        padding: '1px 8px',
        borderRadius: 20,
        background: 'var(--ion-color-warning-shade)',
        color: 'var(--ion-color-warning-contrast)',
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: '0.03em',
        textTransform: 'uppercase' as const
    }
});

/** Says, on every load of the demo, that nobody on the tab is a real person. */
export const InsightsDemoBanner: FC = () => {
    const classes = useStyles();
    // Component state on purpose, so it comes back on the next load. Remembering the dismissal would
    // mean a reader could meet the invented caseload with nothing telling them it is invented,
    // which is the one thing this banner exists to prevent.
    const [dismissed, setDismissed] = useState(false);

    if (dismissed) {
        return null;
    }

    return (
        <div className={classes.banner} data-id="insights-demo-banner">
            <span className={classes.tag}>Demo</span>
            <span>
                Every client and figure on this tab is invented for demonstration. Turn off Insights Demo
                Data in Debug Settings to see your own caseload.
            </span>
            <button
                type="button"
                className={classes.dismiss}
                data-id="insights-demo-banner-dismiss"
                aria-label="Dismiss the demo notice"
                onClick={() => setDismissed(true)}
            >
                &times;
            </button>
        </div>
    );
};
